

<ng-container *ngIf="wrapperClass; else cardTemplate">
    <div [ngClass]="wrapperClass">
        <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
    </div>
</ng-container>
<ng-template #cardTemplate>
    <mat-card [ngClass]="cardClass + ' base-card bg-' + bgcolor">
        <mat-card-header *ngIf="title" [ngClass]="{'hasicon': icon || svgicon, 'hasimg': imgicon}" >
            <ng-content select="[header]"></ng-content>
            <mat-card-title class="p--0 mb--0 mat-text-primary">{{ title }}</mat-card-title>
            <img *ngIf="imgicon" mat-card-sm-image [src]="imgicon" alt="Image">
            <mat-icon mat-card-avatar *ngIf="icon" class="card-icon-bg">{{ icon }}</mat-icon>
            <mat-icon mat-card-avatar *ngIf="svgicon" [svgIcon]="'svg_icon'" class="card-icon-bg"></mat-icon>
        </mat-card-header>
        <mat-card-content [ngClass]="contentClass">
            <ng-content></ng-content>
        </mat-card-content>
    </mat-card>
</ng-template>
